import React from 'react'
import '../../Css/styles2.css'
import '../../Css/bootstrap.css'
import "../../Css/About.css"
import { Container, Row, Col } from 'react-bootstrap';
import { purpose1, purpose2, purpose3, purpose4, about3 } from '../images';
// import {purpose1} from "../../images/purpose1.jpg"


function About() {
  return (
    <div>
      <div className="container-fluid py-5 my-5">
        <div className="container pt-5">
          <div className="row g-5">
            {/* <div className="col-lg-5 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".3s">
              <div className="h-100 position-relative">
                <img src="images/about-1.jpg" className="img-fluid w-75 rounded" alt="" style={{ marginBottom: '20%' }} />
                <div className="position-absolute w-75" style={{ top: '20%', left: '12%' }}>
                  <img src="images/about-2.jpg" className="img-fluid w-100 rounded" alt="" />
                </div>
                <div className="position-absolute w-75" style={{ top: '35%', left: '25%' }}>
                  <img src={about3} className="img-fluid w-100 rounded" alt="" />
                </div>
              </div>
            </div> */}

            <div className="col-lg-5 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".3s">
              <div className="h-100 position-relative">
                <img
                  src="images/about-1.jpg"
                  className="img-fluid w-75 rounded slide-in" // Add the slide-in class
                  alt=""
                  style={{ marginBottom: '20%' }}
                />
                <div className="position-absolute w-75" style={{ top: '20%', left: '12%' }}>
                  <img
                    src="images/about-2.jpg"
                    className="img-fluid w-100 rounded slide-in" // Add the slide-in class
                    alt=""
                  />
                </div>
                <div className="position-absolute w-75" style={{ top: '35%', left: '25%' }}>
                  <img
                    src={about3}
                    className="img-fluid w-100 rounded slide-in" // Add the slide-in class
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".5s">
              <h5 className="text-primary">About Us</h5>
              <h1 className="mb-4">About UPSYS - IT and Marketing Solutions</h1>
              <p  className='justify'>Welcome to UPSYS, a dynamic startup organization committed to revolutionizing the
                way solutions are delivered. With a passion for efficiency and an unwavering
                commitment to quality, we are your partners in achieving your goals, swiftly and
                effectively. At UPSYS, we believe that time is of the essence, and that's why we
                specialize in providing perfect solutions in record time, without compromising on the
                excellence you deserve.</p>
              <p className="mb-4 justify">Our vision at UPSYS is simple yet powerful: to be the forefront of innovation,
                offering
                unparalleled solutions that exceed expectations. We aim to redefine the standard of
                service delivery by combining speed, precision, and expertise to create an
                exceptional experience for every client we work with.</p>
            </div>
          </div>
        </div>
      </div>

      <h2 className='aboutUs-card-heading'>Our <span>Core Values</span></h2>
      <main className="page-content">
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Integrity</h2>
            <p className="copy">We uphold the highest ethical standards in everything we do. Honesty and transparency are at the core of our relationships with our customers, employees and partners we serve.</p>
          </div>
        </div>
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Client-orientation</h2>
            <p className="copy">Our customers are our most valuable asset. We are dedicated to understanding their needs and delivering exceptional value. We actively listen, respond to feedback.</p>
          </div>
        </div>
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Innovation</h2>
            <p className="copy">We embrace innovation as a catalyst for growth and improvement. We encourage creative thinking, experimentation, and a fearless approach to change.</p>
          </div>
        </div>
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Teamwork</h2>
            <p className="copy">We believe that together we achieve more. Collaboration, respect, and open communication are the cornerstones of our teamwork.</p>
          </div>
        </div>
      </main>
      <main className="page-content">
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Excellence</h2>
            <p className="copy">We have an unwavering commitment to excellence. We continuously seek ways to improve, set high standards, and deliver quality in every product, service, and interaction.</p>
          </div>
        </div>
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Accountability</h2>
            <p className="copy">We take ownership of our actions and results. We honor our commitments, and we hold ourselves and each other accountable for our responsibilities.</p>
          </div>
        </div>
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Adaptability</h2>
            <p className="copy">We embrace change as a natural part of progress. We are agile, resilient, and quick to adapt to new circumstances and challenges. Our ability to adapt keeps us ahead in a fast-paced world.</p>
          </div>
        </div>
        <div className="aboutUs-card">
          <div className="content">
            <h2 className="title">Sustainability</h2>
            <p className="copy">We are committed to environmental and social responsibility. We take proactive steps to minimize our environmental impact and support our local communities.</p>
          </div>
        </div>
      </main>
      <br />
      <br />
      <br />
      <br />
      <h2 className='aboutUs-card-heading'>Our <span>Purpose</span></h2>
      <div style={{ marginTop: "3rem" }} className="container highlight">
        <hr />
      </div>
      <div className="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-6  about-second">
              <h2 className="alltext">
                Creating Value for Customers
              </h2>
              <p style={{ fontSize: '18px', color: '#36373b' }}>
                Companies exist to provide products or services that meet the needs and desires of their customers. This involves understanding customer preferences, delivering quality products or services, and continually improving to stay competitive.
              </p>
            </div>
            <div className="col-sm-6 about-col">
              <img
                className="client-img"
                alt="about"
                src={purpose1}

                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>


      <div className="container margin-container">
        <div style={{ marginTop: "4rem" }} className="container highlight">
          <hr />
        </div>
        <div className="about">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 about-col">
                <img
                  className="client-img"
                  alt="about"
                  src={purpose2}
                  loading="lazy"
                />
              </div>
              <div className="col-sm-6  about-second">
                <h2 className="alltext">
                  Generating Profits<span></span>
                </h2>
                <p style={{ fontSize: '18px' }}>
                  One of the primary purposes of a for-profit company is to generate profits for its owners or shareholders. Profitability is essential for sustainability and growth, as it provides the resources needed for investment, expansion, and innovation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "3rem" }} className="container highlight">
        <hr />
      </div>
      <div className="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-6  about-second">
              <h2 className="alltext">
                Creating Employment
              </h2>
              <p style={{ fontSize: '18px', color: '#36373b' }}>
                Companies often create job opportunities, providing employment to individuals and contributing to the overall economy. Job creation can have a positive impact on communities and society as a whole.
              </p>
            </div>
            <div className="col-sm-6 about-col">
              <img
                className="client-img"
                alt="about"
                src={purpose3}

                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>


      <div className="container margin-container">
        <div style={{ marginTop: "4rem" }} className="container highlight">
          <hr />
        </div>
        <div className="about">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 about-col">
                <img
                  className="client-img"
                  alt="about"
                  src={purpose4}
                  loading="lazy"
                />
              </div>
              <div className="col-sm-6  about-second">
                <h2 className="alltext">
                  Innovation and Improvement<span></span>
                </h2>
                <p style={{ fontSize: '18px' }}>
                  Many companies aim to drive innovation and improve existing products or services. This can lead to advancements in technology, increased efficiency, and better solutions for customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />


    </div>
  )
}

export default About

